module.exports = __webpack_public_path__ + "static/media/general-settings.706ce42b.svg";